import { Navigate, Outlet } from 'react-router';
import Navbar from "./components/navigation/Navbar";
import Sidebar from "./components/navigation/Sidebar";
import ChatSidebar from "./components/chat/ChatSidebar";
import { useAuthStore } from './store/authStore';

const ProtectedRoutes = () => {
    const { isAuthenticated } = useAuthStore()

    return isAuthenticated ?
        <div style={{ maxHeight: '100dvh', height: '100dvh', display: 'flex', flexDirection: 'column' }}  >
            <Navbar />

            <div style={{ display: 'flex' }}>
                <Sidebar />
                <div className="outlet" style={{ flex: 1 }}>
                    <Outlet />
                </div>
                <ChatSidebar />
            </div>
        </div > : <Navigate to="/login" replace />;
};

export default ProtectedRoutes